import {
    TemplateJobLineItem,
    LineItemType,
    LineItem,
} from '/types/lineItemTypes';

export const enovaDefaultSettings = {
    enabled: false,
    requiredJobs: [],
    description:
        'Du kan få {CASHBACK_PERCENT} av kostnaden refundert av Enova og spare opptil {CASHBACK_LIMIT} når du kjøper en smart elbillader sammen med Strømkontrollpakke.',
};

export default function useEnova(lineItems: LineItem[]) {
    const enovaCashbackLimit = 10000;
    const enovaCashbackPercent = 35;

    const enovaInfo = (li: TemplateJobLineItem) =>
        li?.data?.jobTypeVersion?.info?.enovaSupport || enovaDefaultSettings;

    const jobs = (lineItems || []).filter(
        (li) => li.type === LineItemType.JOB
    ) as TemplateJobLineItem[];
    const systemDiscounts = (lineItems || []).filter(
        (li) => li.type === LineItemType.SYSTEM_DISCOUNT
    ) as TemplateJobLineItem[];
    const enovaEnabledJobs = jobs.filter((li) => enovaInfo(li).enabled);
    const enovaJobs = enovaEnabledJobs
        .reduce((acc, li) => {
            const requiredJobIds = enovaInfo(li).requiredJobs;
            const requiredJobs = jobs.filter((li) =>
                requiredJobIds.includes(li.data.jobTypeId)
            );
            if (requiredJobIds.length && !requiredJobs.length) {
                return acc;
            }
            return [...acc, li, ...requiredJobs];
        }, [] as TemplateJobLineItem[])
        .filter(
            (li, i, self) =>
                i === self.findIndex((_li) => _li.reference === li.reference)
        );
    const combinedEnovaJobCost = enovaJobs.reduce(
        (acc, li) => acc + li.total.gross,
        0
    );
    const combinedSystemDiscounts = systemDiscounts.reduce(
        (acc, li) => acc + Math.abs(li.total.gross),
        0
    );
    const enovaCashbackAmount = Math.round(
        (combinedEnovaJobCost - combinedSystemDiscounts) *
            (enovaCashbackPercent / 100)
    );

    return {
        enovaJobs,
        enovaCashbackPercent,
        enovaCashbackLimit,
        combinedEnovaJobCost,
        combinedSystemDiscounts,
        enovaCashbackAmount:
            enovaCashbackAmount > enovaCashbackLimit
                ? enovaCashbackLimit
                : enovaCashbackAmount,
    };
}
